import { PackagingApi } from "@/api/packaging";
import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "@common/queryKeys";

// 제작사례 & 포장재리뷰 불러오기
export const useGetGalleryList = () => {
  return useQuery({
    queryKey: QUERY_KEYS.CUSTOMIZING.GALLERY.INDEX,
    queryFn: async () => {
      const res = await PackagingApi({ modes: "GalleryListSet" }); // API 호출

      if (res.Code === "0000") {
        return res.Data?.Data || []; // 정상 데이터 반환
      } else {
        console.error(res?.message); // 에러 처리
      }
    },
    // staleTime: 1000 * 60 * 5, // 5분 동안 데이터 유지
    retry: 1, // 요청 실패 시 한 번만 재시도
  });
};
